/**
 * List of model reference
 */
const model = [
    {
        name: "sword",
        model: "sword",
    }, 
    {
        name: "fish",
        model: "fish",
    },    
    {
        name: "milkTruck",
        model: "milkTruck",
    },    
    {
        name: "fox",
        model: "fox",
    },
    {
        name: "lantern",
        model: "lantern",
    },
    {
        name: "fabricChair",
        model: "fabricChair",
    },
    {
        name: "duck",
        model: "duck",
    },
];
 
export default model;
